import matches from 'validator/lib/matches';
import isEmpty from 'validator/lib/isEmpty';
import {
    createField,
    updateField
} from '../../actions';
import {
    EVENT_STEP_VALIDATE
} from '../../helpers/consts';

export class StreetNameField {
    constructor(options) {
        this.validateMessages = {
            isEmpty: __('Please enter your %s'),
            noWeirdCharacters: __('Only use letters, numbers and symbols.'),
            nameNoTest: __('Did you fall asleep on your keyboard? Try again'),
            minimumNumberOfCharacters: __('Please enter your %s'),
            noHTML: __('No html allowed'),
        };
        this.store = options.store;
        this.state = this.store.getState();
        this.$context = options.$context;
        this.id = options.id;
        this.label = options.label;
        this.placeholder = options.placeholder !== undefined ? options.placeholder : '';
        this.required = options.required !== undefined ? options.required : true;
        this.readOnly = options.readOnly !== undefined ? options.readOnly : false;
        this.stepId = options.stepId
        const fieldState = this.state.formFields.find(field => field.id === this.id);
        this.value = (fieldState && fieldState.value) ? fieldState.value : '';
        this.isValid = (fieldState && fieldState.valid) ? fieldState.valid : false;
        this.$el = this.createFieldElement();

        if (this.value !== '' || !this.required) {
            this.validate();
        }
    }

    createFieldElement() { // eslint-disable-line class-methods-use-this
        let debounceTimeout;
        const $field = document.createElement('div');
        const $fieldLabel = document.createElement('label');
        this.$fieldInput = document.createElement('input');
        this.$fieldMessage = document.createElement('span');

        this.$fieldInput.type = 'text';
        this.$fieldInput.id = this.id;
        this.$fieldInput.required = this.required;
        this.$fieldInput.readOnly = this.readOnly;
        if (this.readOnly) this.$fieldInput.tabIndex = -1;
        this.$fieldInput.placeholder = this.placeholder;
        this.$fieldInput.value = this.value;
        $fieldLabel.setAttribute('for', this.id);
        $fieldLabel.innerHTML = this.label;

        $field.classList.add('field', 'form-group', 'field--text')
        $fieldLabel.classList.add('field-label');
        this.$fieldInput.classList.add('field-input', 'form-control', 'field-input--text');
        this.$fieldMessage.classList.add('invalid-feedback');
        this.$fieldMessage.setAttribute('role', 'alert');

        $field.appendChild($fieldLabel);
        $field.appendChild(this.$fieldInput);
        $field.appendChild(this.$fieldMessage);

        this.store.dispatch(createField(this.id, this.label, this.stepId));
        this.$fieldInput.addEventListener('blur', this.validate.bind(this));
        this.$fieldInput.addEventListener('input', () => {
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(this.validate.bind(this), 100);
        });

        return $field;
    }

    setPlacholder(placholder) {
        this.$fieldInput.placeholder = placholder;
    }

    setValue(value) {
        this.$fieldInput.value = value;
        this.validate(value === '');
    }

    setReadOnly(readOnly) {
        this.readOnly = readOnly;
        this.$fieldInput.readOnly = readOnly;
        this.$fieldInput.tabIndex = readOnly ? -1 : '';
    }

    setFieldMessage(message) {
        this.$fieldMessage.innerHTML = message;
    }

    setNotice() {
        this.$el.classList.add('field--notice');
    }

    validate(_hideMessage = false) {
        const hideMessage = typeof _hideMessage !== 'boolean' ? false : _hideMessage;

        this.$fieldInput.classList.remove('is-valid');
        this.isValid = false;
        this.$fieldMessage.classList.toggle('visually-hidden', hideMessage);

        if (matches(this.$fieldInput.value, /<[^>]+>/g)) {
            // No html allowed
            this.$fieldInput.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.noHTML;
        } else if (matches(this.$fieldInput.value, /[#@%!&$=><,()]/gi)) {
            // Name check on invalid characters
            this.$fieldInput.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.noWeirdCharacters;
        } else if (matches(this.$fieldInput.value, /((test|asdff|asdf|asdasd|qwer|xxx|demo))+/gi)) {
            // No test in the name
            this.$fieldInput.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.nameNoTest;
        } else {
            // Field is valid
            this.$fieldInput.classList.remove('is-invalid');
            this.$fieldInput.classList.add('is-valid');
            this.isValid = true;
        }

        if (isEmpty(this.$fieldInput.value)) {
            if (this.required) {
                this.$fieldInput.classList.add('is-invalid');
                this.$fieldInput.classList.remove('is-valid');
                this.isValid = false;
                this.$fieldMessage.innerHTML = this.validateMessages.isEmpty.replace(/%s/g, this.label);
            } else {
                this.$fieldInput.classList.remove('is-invalid');
                this.$fieldInput.classList.remove('is-valid');
                this.isValid = true;
            }
        }

        if(this.isValid) {
            this.store.dispatch(updateField(this.id, this.$fieldInput.value, this.isValid, this.label));
        }

        if (! this.readOnly) {
            this.$context.dispatchEvent(EVENT_STEP_VALIDATE);
        }
    }

    hide() {
        this.$el.classList.add('visually-hidden');
    }

    show() {
        this.$el.classList.remove('visually-hidden');
    }

    valid() {
        return this.isValid;
    }

    render() {
        return this.$el;
    }
}

export default StreetNameField;
